(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["components"] = factory();
	else
		root["components"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 37);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeQueryParams;
function makeQueryParams(object) {
  var arr = [];

  Object.keys(object).forEach(function (key) {
    if (object[key]) {
      arr.push(encodeURIComponent(key) + '=' + encodeURIComponent(object[key]));
    }
  });

  return arr.join('&');
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/fp/omit");

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(38);


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFromContentful = exports.componentPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _makeQueryParams = __webpack_require__(12);

var _makeQueryParams2 = _interopRequireDefault(_makeQueryParams);

var _omit = __webpack_require__(3);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentPropTypes = exports.componentPropTypes = {
  src: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number,
  sizes: _propTypes2.default.string,
  retina: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  alt: _propTypes2.default.string,
  fit: _propTypes2.default.string,
  quality: _propTypes2.default.number
};

var isFromContentful = exports.isFromContentful = function isFromContentful() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return url.includes("images.contentful.com");
};

var getSrcset = function getSrcset(props) {
  var srcset = [];
  var auto = !isFromContentful(props.src) ? { auto: "format,compress" } : {};

  var params = {
    regular: _extends({
      w: props.width,
      h: props.height ? props.height : null,
      fit: props.fit ? props.fit : null,
      q: props.quality ? props.quality : 70
    }, auto),
    twoThirds: _extends({
      w: parseInt(props.width * 0.66667, 10),
      h: props.height ? parseInt(props.height * 0.66667, 10) : null,
      fit: props.fit ? props.fit : null,
      q: props.quality ? props.quality : 70
    }, auto),
    half: _extends({
      w: parseInt(props.width / 2, 10),
      h: props.height ? parseInt(props.height * 0.5, 10) : null,
      fit: props.fit ? props.fit : null,
      q: props.quality ? props.quality : 70
    }, auto),
    retina: _extends({
      w: parseInt(props.width * 2, 10),
      h: props.height ? parseInt(props.height * 2, 10) : null,
      fit: props.fit ? props.fit : null,
      q: props.quality ? props.quality : 70
    }, auto)
  };

  var connecter = /\?/.test(props.src) ? "&" : "?";

  if (props.retina) {
    srcset.push("" + props.src + connecter + (0, _makeQueryParams2.default)(params.retina) + " 2x");
  }

  if (props.sizes) {
    srcset.push("" + props.src + connecter + (0, _makeQueryParams2.default)(params.regular) + " " + undefined.props.width + "w");
    srcset.push("" + props.src + connecter + (0, _makeQueryParams2.default)(params.twoThirds) + " " + parseInt(props.width * 0.6667, 10) + "w");
    srcset.push("" + props.src + connecter + (0, _makeQueryParams2.default)(params.half) + " " + parseInt(props.width / 2, 10) + "w");
  }

  if (srcset.length === 0) {
    return null;
  }

  return srcset;
};

var getSrc = function getSrc(props) {
  var src = props.src;
  var auto = !isFromContentful(src) ? { auto: "format,compress" } : {};

  var params = _extends({
    w: parseInt(props.width, 10),
    h: props.height ? parseInt(props.height, 10) : null,
    fit: props.fit ? props.fit : null,
    q: props.quality ? props.quality : 70
  }, auto);
  var connecter = /\?/.test(props.src) ? "&" : "?";
  return "" + src + connecter + (0, _makeQueryParams2.default)(params);
};

var CloudImageSrcset = function CloudImageSrcset(props) {
  return _react2.default.createElement("img", _extends({}, (0, _omit2.default)(["retina", "fit", "quality"])(props), {
    src: getSrc(props),
    key: props.src,
    srcSet: getSrcset(props),
    alt: props.alt || ""
  }));
};

CloudImageSrcset.propTypes = componentPropTypes;

exports.default = CloudImageSrcset;

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/wonderbly-components/lib/CloudImageSrcset.js
// module id = 1553
// module chunks = 0